import { Youtube } from "lucide-react";
import { FadeUp, Stagger, StaggerItem } from "@/components/Reveal";
import { EpisodeCard } from "@/components/EpisodeCard";
import { EPISODES, YOUTUBE_CHANNEL } from "@/data/content";
import { useLang } from "@/i18n/LanguageContext";

export default function Podcast() {
  const { t } = useLang();
  const p = t.podcastPage;

  return (
    <>
      <section data-testid="podcast-header" className="pt-32 sm:pt-40 pb-14 max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
        <FadeUp className="max-w-3xl">
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-terracotta mb-4">{p.kicker}</p>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight leading-[1.08] text-balance">
            {p.title}
          </h1>
          <p className="mt-6 text-base sm:text-lg text-clay leading-relaxed max-w-2xl">{p.intro}</p>
          <div className="mt-8 flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <a
              href={YOUTUBE_CHANNEL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="podcast-subscribe-btn"
              className="inline-flex items-center gap-2 rounded-full bg-terracotta text-linen px-6 py-3 text-sm font-semibold transition-[background-color,transform] duration-200 hover:bg-terracotta-dark [@media(hover:hover)]:hover:-translate-y-0.5"
            >
              <Youtube className="w-5 h-5" /> {p.subscribe}
            </a>
          </div>
        </FadeUp>
      </section>

      <section data-testid="episodes-grid-section" className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 pb-16 sm:pb-24">
        <FadeUp className="mb-10">
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-taupe">
            {p.allEpisodes} · {EPISODES.length}
          </p>
        </FadeUp>
        <Stagger className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {EPISODES.map((ep) => (
            <StaggerItem key={ep.id}>
              <EpisodeCard ep={ep} />
            </StaggerItem>
          ))}
        </Stagger>
      </section>

      <section data-testid="podcast-subscribe-banner" className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 pb-20 text-center">
        <FadeUp>
          <p className="text-base sm:text-lg text-clay">
            {p.comingSoonPre}
            <a
              href={YOUTUBE_CHANNEL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="podcast-coming-soon-link"
              className="font-semibold text-terracotta hover:text-terracotta-dark transition-colors"
            >
              {p.comingSoonLink}
            </a>
            {p.comingSoonPost}
          </p>
        </FadeUp>
      </section>
    </>
  );
}
